import {
  OrganizationRapport,
  SurveyCustomerExperienceOptions,
} from '../appointmentProposalSurveyOptions.models';

export const transformRapportOptions = (
  rapportOptions: OrganizationRapport[],
  groupName: 'EXPERIENCE' | 'PREFERENCES',
  staticOptions: SurveyCustomerExperienceOptions[]
): SurveyCustomerExperienceOptions[] =>
  rapportOptions
    .filter((option) => option.groupName === groupName)
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map((option) => {
      const matchingStaticOption = staticOptions.find(
        (staticOption) =>
          staticOption.label.toLowerCase() === option.name.toLowerCase()
      );

      return {
        id: option.rapportId,
        label: option.name,
        icon: matchingStaticOption?.icon || undefined,
      };
    });
